import React from "react";
import styled, { css } from "styled-components";
import NewBadge from "./NewBadge";
import { DeviceType } from "models/DeviceType";

interface GnbItemProfileProps extends React.HTMLAttributes<HTMLDivElement> {
  name?: string;
  device?: DeviceType;
  isNew?: boolean;
}

const GnbItemProfile = ({
  name,
  device,
  isNew,
  ...rest
}: GnbItemProfileProps) => {
  const isMobile = device === "mobile";

  return (
    <WrapStyle {...rest} device={device}>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="28"
        height="28"
        viewBox="0 0 28 28"
        fill="none"
      >
        <path
          d="M3 23.7538C3 19.4277 6.61429 15.9206 14 15.9206C21.3857 15.9206 25 19.4277 25 23.7538C25 24.4421 24.4979 25 23.8784 25H4.12157C3.50214 25 3 24.4421 3 23.7538Z"
          fill="currentColor"
        />
        <path
          d="M18.125 7.125C18.125 9.40317 16.2782 11.25 14 11.25C11.7218 11.25 9.875 9.40317 9.875 7.125C9.875 4.84682 11.7218 3 14 3C16.2782 3 18.125 4.84682 18.125 7.125Z"
          fill="currentColor"
        />
      </svg>

      {!isMobile && <NameStyle>{name}</NameStyle>}

      {isNew && <NewBadge />}
    </WrapStyle>
  );
};

export default GnbItemProfile;

/* 스타일 */
const WrapStyle = styled.div<{ device?: DeviceType }>`
  border-radius: 0.8rem;

  display: inline-flex;
  align-items: center;
  gap: 0.6rem;
  position: relative;

  cursor: pointer;

  svg {
    color: ${({ theme }) => theme.color.grey[500]};
  }

  &:hover {
    background: ${({ theme }) => theme.color.grey[300]};
  }

  &:active {
    background: ${({ theme }) => theme.color.grey[300]};

    svg {
      color: ${({ theme }) => theme.color.grey[600]};
    }
  }

  ${({ device }) =>
    device !== "mobile"
      ? css`
          padding: 0.4rem 0.6rem;

          svg {
            width: 2.8rem;
            height: 2.8rem;
          }
        `
      : css`
          padding: 0.4rem;

          svg {
            width: 2rem;
            height: 2rem;
          }
        `}
`;

const NameStyle = styled.p`
  width: 4.1rem;
`;
